import { render } from "./IntakePluginCapture.vue?vue&type=template&id=84214c46&scoped=true"
import script from "./IntakePluginCapture.vue?vue&type=script&lang=js"
export * from "./IntakePluginCapture.vue?vue&type=script&lang=js"

import "./IntakePluginCapture.vue?vue&type=style&index=0&id=84214c46&scoped=true&lang=css"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84214c46"]])

export default __exports__